module.exports = __webpack_public_path__ + "static/media/p_4.8f4fb425.jpg";